module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_8.43169dda.jpg";